import { batch } from 'react-redux';
import { resetBondsFilter } from '@/finsight/application/actions/bonds/filters/actions';
import { resetState as resetMetadata } from '@/finsight/application/actions/bonds/metadata/actions';
import { SessionService } from '@/users/application/Session/SessionService';
import UserPermission from '@/users/domain/UserPermission';

export const checkAuthBonds = () => async (dispatch, getState) => {
  const sessionService = getState().container.get(SessionService);
  try {
    await sessionService.checkSession({
      accessPermissions: UserPermission.managerAccess,
      logoutParams: { redirect: false },
    });
    return true;
  } catch (e) {
    return false;
  }
};

export const fullResetBondsPage = () => (dispatch) => batch(() => {
  dispatch(resetBondsFilter());
  dispatch(resetMetadata());
});
